<div class="main_body">
  <app-page-header [title]="userTypeDisp" [icon]="userType === 'CONTRIBUTOR' ? 'contributor' : 'staff'">
    <p slot="subtitle" class="page-header__subtitle" i18n="@@adminSection.staffList.message.description">
      {{ userTypeDisp }}情報の閲覧・編集・停止・再開の設定を行います。
      @if (userType === 'CONTRIBUTOR') {
        <span>多職種スタッフはユーザーひとりひとりに閲覧権限を割り当てるスタッフです。</span>
      }
    </p>
  </app-page-header>
  <div class="contents">
    <div class="contents_section_group">
      <section class="contents__section">
        <div class="table-toolbar">
          <!-- Left: Search Pill -->
          <div
            class="search-pill"
            [class.expanded]="searchExpanded()"
            [class.has-value]="filter.trim()"
            (click)="expandSearch()"
            role="search"
          >
            <mat-icon class="search-pill__icon">search</mat-icon>
            @if (!searchExpanded() && !filter.trim()) {
              <span class="search-pill__placeholder">{{ i18n.filterPlaceholder(userTypeDisp) }}</span>
            }
            <input
              #searchInput
              type="text"
              class="search-pill__input"
              [value]="filter"
              (input)="applyFilter($event)"
              (blur)="onSearchBlur()"
              [attr.aria-label]="i18n.filterPlaceholder(userTypeDisp)"
            />
            @if (filter.trim()) {
              <button
                type="button"
                class="search-pill__clear"
                (click)="clearSearch($event)"
                aria-label="検索をクリア"
                i18n-aria-label="@@adminSection.staffList.search.clearAriaLabel"
              >
                <mat-icon>close</mat-icon>
              </button>
            }
          </div>

          <!-- Right: Actions -->
          <div class="table-toolbar__actions">
            <button
              mat-icon-button
              class="table-toolbar__btn"
              (click)="inviteStaff()"
              [matTooltip]="i18n.invite(userTypeDisp)"
              [attr.aria-label]="i18n.invite(userTypeDisp)"
            >
              <mat-icon>person_add</mat-icon>
            </button>
            <button
              mat-icon-button
              class="table-toolbar__btn"
              (click)="refreshData()"
              matTooltip="更新"
              aria-label="更新"
              i18n-matTooltip="@@adminSection.staffList.tooltip.refresh"
              i18n-aria-label="@@adminSection.staffList.ariaLabel.refresh"
            >
              <mat-icon>refresh</mat-icon>
            </button>
          </div>
        </div>

        <div class="user-list-container mat-elevation-z0">
          @if (isLoading()) {
            <app-table-skeleton [rows]="5" />
          } @else {
            <table class="entry-table staff" mat-table [dataSource]="dataSource" matSort matSortActive="status" matSortDirection="desc">

              <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="name-column" i18n="@@adminSection.staffList.label.name"> 氏名 </th>
                <td mat-cell *matCellDef="let row" class="name-column">
                  @if (row.id == loginUserId) {
                    <span class="name-column__content">
                      <span class="name-column__text">{{row.name}}</span>
                      <span class="status-badge status-badge--active name-column__self" title="You">You</span>
                    </span>
                  } @else {
                    <span class="name-column__text">{{row.name}}</span>
                  }
                </td>
              </ng-container>

              <ng-container matColumnDef="userjob">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 70px;" i18n="@@adminSection.staffList.label.jobTitle"> 職種 </th>
                <td mat-cell *matCellDef="let row">
                  <span>{{getuserJobTitle(row.userjob)}}</span>
                </td>
              </ng-container>

              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef mat-sort-header style="min-width: 90px;" i18n="@@adminSection.staffList.label.status"> ステータス </th>
                <td mat-cell *matCellDef="let row">
                  @if (row.status == 'OPEN') {
                    <span class="status-badge status-badge--active">{{accountStatus[row.status]}}</span>
                  } @else {
                    <span class="status-badge status-badge--inactive">{{accountStatus[row.status]}}</span>
                  }
                </td>
              </ng-container>

              <ng-container matColumnDef="createdDate">
                <th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@adminSection.staffList.label.createdDate"> アカウント作成日 </th>
                <td mat-cell *matCellDef="let row" class="table-cell-date"> {{row.createdDate}} </td>
              </ng-container>

              <!-- Actions Column (hover reveal - 3 icons side by side) -->
              <ng-container matColumnDef="actions" stickyEnd>
                <th mat-header-cell *matHeaderCellDef class="actions-header"></th>
                <td mat-cell *matCellDef="let row" class="actions-cell">
                  <div class="staff-actions-group">
                    <!-- スタッフ情報 -->
                    <button
                      mat-icon-button
                      class="staff-action-button"
                      (click)="openStaffDetailsDialog(row.id)"
                      matTooltip="スタッフ情報"
                      i18n-matTooltip="@@adminSection.staffList.tooltip.staffInfo"
                      aria-label="スタッフ情報を表示"
                      i18n-aria-label="@@adminSection.staffList.ariaLabel.staffInfo"
                    >
                      <mat-icon class="staff-action-icon">assignment_ind</mat-icon>
                    </button>
                    <!-- 権限設定 -->
                    <button
                      mat-icon-button
                      class="staff-action-button"
                      [disabled]="row.status === 'CLOSE'"
                      (click)="openStaffRolesDialog(row.id)"
                      matTooltip="権限設定"
                      i18n-matTooltip="@@adminSection.staffList.tooltip.roles"
                      aria-label="権限設定"
                      i18n-aria-label="@@adminSection.staffList.ariaLabel.roles"
                    >
                      <mat-icon class="staff-action-icon">settings</mat-icon>
                    </button>
                    <!-- アカウント停止/再開 -->
                    @if (row.status === 'OPEN') {
                      <button
                        mat-icon-button
                        class="staff-action-button staff-action-button--danger"
                        (click)="openStaffActivationDialog(row.id)"
                        matTooltip="アカウント停止"
                        i18n-matTooltip="@@adminSection.staffList.tooltip.deactivate"
                        aria-label="アカウント停止"
                        i18n-aria-label="@@adminSection.staffList.ariaLabel.deactivate"
                      >
                        <mat-icon class="staff-action-icon">person_off</mat-icon>
                      </button>
                    }
                    @if (row.status === 'CLOSE') {
                      <button
                        mat-icon-button
                        class="staff-action-button staff-action-button--success"
                        (click)="openStaffActivationDialog(row.id)"
                        matTooltip="アカウント再開"
                        i18n-matTooltip="@@adminSection.staffList.tooltip.activate"
                        aria-label="アカウント再開"
                        i18n-aria-label="@@adminSection.staffList.ariaLabel.activate"
                      >
                        <mat-icon class="staff-action-icon">how_to_reg</mat-icon>
                      </button>
                    }
                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                [class.row-self]="loginUserId === row.id"
                [class.row-closed]="row.status === 'CLOSE'">
              </tr>
            </table>
          }
        </div>
        <mat-paginator class="user-list-paginator" [pageSize]="50" [pageSizeOptions]="[5, 10, 25, 50, 100]"></mat-paginator>
      </section>
    </div>
    <!--/contents_section_group-->
  </div>
  <!--/contents-->
</div>
